module.exports = __webpack_public_path__ + "images/ligier4b9fc4de1412ba063d78885f5e96bf68.png";